import React, {useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';

import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import {useHistory, useParams} from "react-router-dom";
import {Actions} from "../../../client/Actions";
import {Button, Card, Col, Row} from "react-bootstrap";
import ManagementAction from "../../components/actions/ManagementAction";
import ManagementHistoryTable from "./history/ManagementHistoryTable";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import {FormatHeader} from "../format/FormatHeader";
import { useActions } from "../../helpers/actions";
import PartsTable from "../format/PartsTable";
import {hasFormatsFullAccess} from "../../helpers/jwt";
import { useModels } from "../../helpers/models";

const ManagementPage = (props) => {
    const { t } = useTranslation();

    let {id} = useParams();
    const history = useHistory();
    const models = useModels();
    const actions = useActions();

    const [loader, setLoader] = useState(false);
    const [format, setFormat] = useState();
    const [reload, setReload] = useState(false);

    const [cleaningContext, setCleaningContext] = useState();
    const [storageContext, setStorageContext] = useState();


    function loadData() {
        setLoader(true);
        Actions.get("format/" + id, dataLoaded);
    }


    function dataLoaded(data) {
        setFormat(data);
        setLoader(false);
    }


    useEffect(loadData, [reload]);


    return (<>
        <Loader loader={loader}/>
        {format &&
            <CustomContainer title={t("menu.format_management")}
                             parent={
                                 <>
                                     <LinkIconButton
                                         model={models.format}
                                         props={props}
                                     />
                                     <LinkIconButton
                                         model={models.management}
                                         link={models.management.url + "/" + id}
                                         props={props}
                                     />
                                 </>
                             }
                             subtitle={
                                 <FormatHeader format={format}
                                               showDetails={true}
                                               disableDataAndUser={true}
                                               formatId={format.id}/>
                             }
            >

                <Col md={8}>

                    <Row className={"mb-5"}>
                        <Col md={12} className="text-center m-auto">
                            <Card id="management-actions">
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <p className="text-primary size-50">
                                                <i className={"fas " + models.management.icon}/>
                                            </p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <>
                                                {
                                                    actions
                                                        .filter(a => !a.hide)
                                                        .filter(a => hasFormatsFullAccess() ? true : a.showAlways)
                                                        .map(action =>
                                                            <>
                                                                <Button
                                                                    variant="outline-dark"
                                                                    size="lg"
                                                                    className={"management-button border-none shadow card"}
                                                                    onClick={() => history.push(models.management.url + "/" + id + "/" + action.model.url)}
                                                                >
                                                                    <i className={"fas " + action.model.icon}/>{action.model.title}
                                                                </Button>
                                                            </>
                                                        )
                                                }

                                            </>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    <Row>
                        <ManagementHistoryTable
                            reload={reload}
                            id={id}/>
                    </Row>
                </Col>
                <Col md={4}>
                    <PartsTable
                        format={format}
                        setLoader={setLoader}
                        short={true}
                        readOnly={true}
                        showStatusAlways={true}
                        additionalFilter={part => part.status !== "WITHDRAWN"}
                    />
                </Col>
            </CustomContainer>
        }

        {cleaningContext && <ManagementAction
            title="Czyszczenie/Suszenie"
            icon="fa-burn"
            showModal={cleaningContext.show}
            actionName="cleaning"
            selectable={true}
            generatedId={id}
            setShowModal={(value) => {
                setCleaningContext({...cleaningContext, show: value});
                setReload(!reload);
            }}
            onFinish={() => setCleaningContext(undefined)}
            loader={loader}
            setLoader={setLoader}
        />}


        {storageContext && <ManagementAction
            title="Przechowywanie"
            icon="fa-warehouse"
            showModal={storageContext.show}
            actionName="storage"
            generatedId={id}
            setShowModal={(value) => {
                setStorageContext({...storageContext, show: value});
                setReload(!reload);
            }}
            onFinish={() => setStorageContext(undefined)}
            loader={loader}
            setLoader={setLoader}
        />}


    </>);
};


export default ManagementPage;